import htmlParser from 'html-react-parser';
import { richTextParser } from '../../../utils/richTextParser';
import { Collapse } from '../../layout-d/Motion/Collapse';
import { ICollapsedCardProp } from './interface';

const CollapsedCard = ({ index, openingIdx, FaqData }: ICollapsedCardProp) => {
  return (
    <Collapse isOpened={index === openingIdx}>
      <div
        className={`md:pl-6 md:pr-6 px-4 pb-4 md:pb-6  text-sm overflow-hidden transition-all duration-700 ${
          index === openingIdx ? 'max-h-full' : 'max-h-0'
        }`}
      >
        <div className="editor-master">{htmlParser(richTextParser(FaqData))}</div>
      </div>
    </Collapse>
  );
};

export default CollapsedCard;
